import { createCompanyDetailsSlice } from 'common/stores/redux/ContractorCompanyDetails';

const contractorCompanyDetailsSlice = createCompanyDetailsSlice(
    'contractorCompanyDetails'
);

export const {
    init,
    replace,
    addNote,
    addRating,
    updateNote,
    addFile,
    removeFile,
    addQualification,
    removeQualification,
    addBlocklistItem,
    removeBlocklistItem,
    replaceBlocklistItem,
} = contractorCompanyDetailsSlice.actions;

export default contractorCompanyDetailsSlice.reducer;
